

module pze {
  'use strict';

  export class PzeCtrl implements ng.IController  {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      'pzeService',
      '$filter',
      'visibilityApiService',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IPzeCtrl,
      private pzeService: pze.IPzeService,
      private $filter: ng.IFilterService,
      private visibilityApiService: navigation.IVisibilityApiService
    ) {

      $scope.vm = this;     
      $scope.icalurl = null;

      visibilityApiService.subscribeOnVisibilityChange($scope, (ev: ng.IAngularEvent, isHidden: boolean) => {
        if (!isHidden) {
          $scope.vm.refresh(null);
        }
      });

      this.pzeService.timesByDate(this.dayStart, this.dayEnd).then((v) => {        
        this.$scope.times = v.data.data.timesByDate; 
      });      
    }

    dayStart = new Date(new Date().setDate(new Date().getDate() - 7));
    dayEnd = new Date();

    dayStartHour = 6;
    dayEndHour = 23;


    getHourInPercent(hour : number, absolute: boolean):number {
      var h = absolute ? (hour - this.dayStartHour) : hour;
      var p = h / (this.dayEndHour - this.dayStartHour);
      return p * 100;
    }

    getFormatedTime(time: string) {
      return this.$filter('date')(Date.parse('2000-01-01 ' + time), "HH:mm");
    }
    

    loadMoreData(ev :  MouseEvent) { 
      var oldStart = new Date(this.dayStart.setDate(this.dayStart.getDate() - 1));
      this.dayStart = new Date(this.dayStart.setDate(this.dayStart.getDate() - 8));
      this.pzeService.timesByDate(this.dayStart, oldStart).then((v) => {        
        v.data.data.timesByDate.forEach((w) => { 
          this.$scope.times.push(w); 
        })
      });      
    }

    refresh(ev: MouseEvent) { 
      this.dayEnd = new Date(); //maybe "today" has changed if user keeps page open through midnight.
      this.pzeService.timesByDate(this.dayStart, this.dayEnd).then((v) => {        
        this.$scope.times =  v.data.data.timesByDate; 
      });
    }

    getDifference(t: api_photometer.Time) : number {
      if (!t.totalSystemPaidHours) return null;
      var diff = t.totalSystemPaidHours - t.totalPaidHours;
      if (Math.abs(diff) < 0.1) return null;
      return diff;
    }
    
    decToTime(hours: number): string {
      var h = Math.trunc(hours);
      var m = Math.trunc((hours - h) * 60);
      return ("00" + h).slice(-2) +  ":" + ("00" + m).slice(-2)
    }

    getSaldo(): number {
      if (!this.$scope.times) return;
      var saldo = 0;
      this.$scope.times.forEach((t) => {
        if (t.projectedEndOfWorkday == "00:00:00") { 
          saldo += t.totalPaidHours - 8.5;
        }
      });
      return saldo;
    }

    loadICalUrl() {      
      this.pzeService.personalIcalUrl().then((v) => {        
        this.$scope.icalurl = pglob.RouteData.PhotometerApiBaseUrl + v.data.data.personalIcalUrl; 
      });      
    }


  }
};
